import { Logger } from '@as-react/logger';
import { eventChannel } from 'redux-saga';
import { call, put, take } from 'redux-saga/effects';
import { EventEnum } from '@as-react/common-types';
import { GeneralActionTypes } from '../../enums/ActionEnums';
import { EventUtil } from '@as-react/common-utils';
const createCustomEventChannel = () => {
    return eventChannel(emit => {
        const handleEventCall = (event) => {
            emit({
                eventType: event.type,
                data: event.detail && event.detail !== '' ? event.detail : null,
            });
        };
        const subscribe = () => {
            Object.keys(EventEnum).forEach(key => {
                EventUtil.listen(EventEnum[key], handleEventCall);
            });
        };
        const unsubscribe = () => {
            Object.keys(EventEnum).forEach(key => {
                EventUtil.remove(EventEnum[key], handleEventCall);
            });
        };
        subscribe();
        return unsubscribe;
    });
};
export function* watchForCustomEvents() {
    const customEventChannel = yield call(createCustomEventChannel);
    while (true) {
        try {
            const payload = yield take(customEventChannel);
            yield put({
                type: GeneralActionTypes.CUSTOM_EVENT,
                payload,
            });
        }
        catch (error) {
            Logger.logError(error);
        }
    }
}
